import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { HashLink } from "react-router-hash-link"
import { AiOutlineMenuUnfold, AiOutlineMenuFold } from "react-icons/all"

import logo from "../assets/images/logo.png"

const Container = () => {
  const [isNav, setNav] = useState(false)
  const openNav = () => {
    setNav(true)
  }
  const closeNav = () => {
    setNav(false)
  }
  return (
    <div className="container">
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="soz logo" height="60" width="auto" />
        </Link>
      </div>
      <div className="burger open" onClick={openNav}>
        <AiOutlineMenuFold className="icon" />
      </div>
      <nav className={isNav ? "nav-open" : ""}>
        <div className="top-view">
          <div className="burger close" onClick={closeNav}>
            <AiOutlineMenuUnfold className="icon" />
          </div>
          <h2>Soz Product & Services</h2>
        </div>
        <ul>
          <li>
            <Link
              to="/beats"
              onClick={closeNav}
              className={isNav ? "navlink navlink-1" : ""}
            >
              Beats
            </Link>
          </li>
          <li>
            <Link
              to="/releases"
              onClick={closeNav}
              className={isNav ? "navlink navlink-2" : ""}
            >
              Releases
            </Link>
          </li>
          {/* <li>
            <Link
              to="/sing-thursday"
              onClick={closeNav}
              className={isNav ? "navlink navlink-1" : ""}
            >
              Sing Thursday
            </Link>
          </li> */}
          {/* <li>
            <Link
              to="/team"
              onClick={closeNav}
              className={isNav ? "navlink navlink-2" : ""}
            >
              Team
            </Link>
          </li> */}
          <li>
            <HashLink
              to="/#services"
              onClick={closeNav}
              className={isNav ? "navlink navlink-3" : ""}
            >
              Our Services
            </HashLink>
          </li>
          <li>
            <HashLink
              to="/#about"
              onClick={closeNav}
              className={isNav ? "navlink navlink-4" : ""}
            >
              About us
            </HashLink>
          </li>
          {/* <li>
            <Link
              to="/contact-us"
              onClick={closeNav}
              className={isNav ? "navlink navlink-1" : ""}
            >
              Contact
            </Link>
          </li> */}
        </ul>
      </nav>
    </div>
  )
}

const Header = () => {
  const [reveal, setReveal] = useState(false)
  const [scrollDown, setScrollDown] = useState(false)
  const [lastYPos, setLastYPos] = useState(0)

  useEffect(() => {
    function handleScroll() {
      const yPos = window.scrollY
      const isScrollingUp = yPos < lastYPos

      if (yPos > 1000) {
        if (isScrollingUp) {
          setReveal(isScrollingUp)
        } else {
          setReveal(false)
        }
      } else {
        setReveal(false)
      }
      setLastYPos(yPos)
    }

    window.addEventListener("scroll", handleScroll, false)
    return () => {
      window.removeEventListener("scroll", handleScroll, false)
    }
  }, [lastYPos])

  //   useEffect(() => {
  //     function handleScroll() {
  //       const yPos = window.scrollY
  //       const isScrollingDown = yPos > lastYPos
  //       if (yPos > 500) {
  //         if (isScrollingDown) {
  //           setScrollDown(isScrollingDown)
  //         } else {
  //           setScrollDown(false)
  //         }
  //       } else {
  //         setScrollDown(false)
  //       }
  //       setLastYPos(yPos)
  //     }
  //     window.addEventListener("scroll", handleScroll, false)
  //     return () => {
  //       window.removeEventListener("scroll", handleScroll, false)
  //     }
  //   }, [lastYPos])

  //   if (reveal) {
  //     return (
  //       <header className="top-header sticky-header">
  //         <Container />
  //       </header>
  //     )
  //   }
  //   else if (scrollDown) {
  //     return (
  //       <header className="top-header scrolled-down">
  //         <Container />
  //       </header>
  //     )
  //   }
  //   else {
  return (
    <header className="top-header">
      <Container />
    </header>
  )
  //   }
}

export default Header
